<template>   
    <div>
        <!-- <div class="accessIndex__reload--container"
            @click="previousSelection()">
            <i class="material-icons" style="color: #009CDE">keyboard_backspace</i>
        </div> -->
        <div class="structure_date">
            <div class="structure_date__date">
                <p>Selecciona la fecha</p>
                <select name="" id="" 
                    v-model="myActualDate.month" 
                    @change="getScheduleDays()">
                    <option v-for="(mon,index) in three_month"  
                        :value="mon.value" 
                        :key="index">
                        {{ mon.name }}
                    </option>
                </select> 
            </div>
            <div class="structure_date__quota">
                <p>No hay disponibilidad</p>
                <div> 1 </div>
            </div>
        </div>
        <div class="calendar">
            <div class="calendar__name_days">
                <div> Lunes </div>
                <div> Martes </div> 
                <div> Miércoles </div>
                <div> Jueves </div>
                <div> Viernes </div>
                <div> Sábado </div>
                <div> Domingo </div>
            </div>
            <div class="calendar__days">
                <div
                v-for="(month,index) in month.days" :key="index"
                :class="month.current_month === false ? 
                'calendar__days--previous_month'
                :month.active === true ? 'calendar__days--normal' : 'calendar__days--inactive'"
                :style="month.active === true && month.click === true ? 'background-color: #000000; color: #ffffff' : '' "
                >
                <section @click.stop="mapDays(index); changeDate(month.active,month.value);" >
                <span>{{ month.value }}</span>
                </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                my_date:"",
                date_select: "",
                three_month: [],
                select_days: {},
                new_year: 0,
                months: [ 
                    { id:  1, value: '01', name: 'Enero'      },
                    { id:  2, value: '02', name: 'Febrero'    },
                    { id:  3, value: '03', name: 'Marzo'      },
                    { id:  4, value: '04', name: 'Abril'      },
                    { id:  5, value: '05', name: 'Mayo'       },
                    { id:  6, value: '06', name: 'Junio'      },
                    { id:  7, value: '07', name: 'Julio'      },
                    { id:  8, value: '08', name: 'Agosto'     },
                    { id:  9, value: '09', name: 'Septiembre' },
                    { id: 10, value: '10', name: 'Octubre'    },
                    { id: 11, value: '11', name: 'Noviembre'  },
                    { id: 12, value: '12', name: 'Diciembre' }, 
                ],
                month: {},
                myActualDate:{day:0,month:0,year:0},
                myOriginDate:{month:0,year:0},                                      
            }
        },
        props: ["sublocation"],
        computed:{
            isActualDate(){         
                return this.myActualDate.year==this.myOriginDate.year&&this.myActualDate.month==this.myOriginDate.month
            }
        },
        methods: {    
            getScheduleDays(){             
                var vm = this;
                vm.new_year = vm.myActualDate.year
                if(vm.three_month[0].id > 10) {
                    if(vm.myActualDate.month < 10 && vm.myActualDate.month > 0){
                        vm.new_year = vm.myActualDate.year + 1
                    }
                }
                try{
                    vm.$http.get('app/bookings/schedule_days_dashboard', {
                        headers: {
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        },
                        params:{sublocation_id: vm.sublocation[0].id,
                                user_company: vm.$attrs.user[0].user_company,
                                actual: vm.isActualDate,
                                day: vm.myActualDate.day,
                                month: vm.myActualDate.month,
                                year: vm.new_year  
                                }
                    }).then(function(response){
                        vm.select_days = response.body;
                        this.armMonth();
                        console.log(response)
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            } 
                        }
                        console.log("Respuesta error de reservas");
                        if (response.status==401) { 
                            // this.updateAlertMessage(response.body.errors[0].details, "Un momento...");
                            this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                            this.updateIsInAlert(true)
                        }else{
                            this.updateAlertMessage(response.body.errors[0].details);
                            this.updateIsInAlert(true)
                        }
                    });
                }catch(e){
                    console.log("Fallo reservas home");
                    this.updateAlertMessage(e.message);
                }

                vm.is_changed = false;
            },
            changeDate(month_active,day){ 
                if (month_active===true) {
                    let dd = day;
                    if (dd < 10){
                    dd = "0" + dd
                    }                
                    var userAgent = window.navigator.userAgent; 
                    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || this.IsSafari() ) {
                        /* console.log('if =================') */
                        this.date_select = this.new_year + "/" + this.myActualDate.month + "/" + dd + " 00:00:00" 
                    }
                    else {
                        /* console.log('else =================') */
                        this.date_select = this.new_year + "-" + this.myActualDate.month + "-" + dd + " 00:00:00"
                    }
                    let date = new Date(this.date_select)      
                    this.$emit("selected", date)
                }
            },
            IsSafari() {
                var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
                return is_safari;
            },
            armMonth(){
                /*let invalid_days = [4,10,20,25]
                let structure = [{value:1, name:"friday"},{value :31, name:"sunday"}]
                let extra_days = [[27,28,29,30],[1]] */
                let weekday = new Array(7);
                weekday[0] = "sunday";
                weekday[1] = "monday";
                weekday[2] = "tuesday";
                weekday[3] = "wednesday";
                weekday[4] = "thursday";
                weekday[5] = "friday";
                weekday[6] = "saturday";
                let days = [];
                let initial_day = this.select_days.structure[0].name;
                let last_day = this.select_days.structure[1].name; 
                let index = 6 - weekday.indexOf(initial_day) 
                for(let i = 0 ; i < this.select_days.extra_days[0].length ; i++){
                if (index > 6){
                    index = 0
                }
                this.select_days.invalid_days.find(e => e === this.select_days.extra_days[0][i])
                days.push({ number: index, name: weekday[index], value: this.select_days.extra_days[0][i], active: false, current_month: false }); 
                index += 1;
                }
                let index_current = weekday.indexOf(initial_day) 
                for(let l = this.select_days.structure[0].value; l <= this.select_days.structure[1].value; l++){
                if (index_current > 6){
                    index_current = 0
                }
                let active = true
                if (this.select_days.invalid_days.find(e => e === l )){
                    active = false  
                }
                days.push({ number: index_current, name: weekday[index_current], value: l, active: active, current_month: true }); 
                index_current += 1;
                }
                let index_next = weekday.indexOf(last_day) + 1
                for(let k = 0 ; k < this.select_days.extra_days[1].length ; k++){
                if (index_next > 6){
                    index_next = 0
                }
                this.select_days.invalid_days.find(e => e === this.select_days.extra_days[0][k])
                days.push({ number: index_next, name: weekday[index_next], value: this.select_days.extra_days[1][k], active: false, current_month: false }); 
                index_next += 1;
                }
                this.month = { month_number: null, month_name: null, days: days }
                return this.month 
            },
            threeMonth(){
                let date = new Date();
                this.months 
                let index = date.getMonth() 
                for(let i = 1;i <= 3; i++){
                if (index > 11) {
                    index = 0      
                }
                this.three_month.push(this.months[index]) 
                index += 1
                }
            },
            mapDays(findex){
                this.month.days.forEach(m => m.click = false); 
                this.month.days[findex].click = true
            },
        },/* closed methods */
        mounted(){
            this.threeMonth();

            let s_date= new Date()
            let clientOffset=new Date().getTimezoneOffset() 
            let ans= new Date(s_date.getTime() - (clientOffset*60000)) 
            var zoneActualDate=ans.toISOString().substr(0, 10).split("-") 
            this.myOriginDate.year= Number(zoneActualDate[0])
            this.myOriginDate.month= zoneActualDate[1] 
            this.myOriginDate.day=zoneActualDate[2]
            this.myActualDate.year= Number(zoneActualDate[0])
            this.myActualDate.month= zoneActualDate[1] 
            this.myActualDate.day=zoneActualDate[2]
            console.log(this.myActualDate);
            this.getScheduleDays();
            console.log('user rut!!!', this.$attrs.user)
        },
        
    }
</script>



// WEBPACK FOOTER //
// src/components/views/bookings/DateSelect.vue